"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolutionBreakpoints = void 0;
const types_1 = require("root/src/client/v2/browser/types");
exports.resolutionBreakpoints = {
    [types_1.WindowBreakpoint.Xs]: '(max-width: 599px)',
    [types_1.WindowBreakpoint.GtXs]: '(min-width: 600px)',
    [types_1.WindowBreakpoint.Sm]: '(min-width: 600px) and (max-width: 959px)',
    [types_1.WindowBreakpoint.GtSm]: '(min-width: 960px)',
    [types_1.WindowBreakpoint.Md]: '(min-width: 960px) and (max-width: 1279px)',
    [types_1.WindowBreakpoint.GtMd]: '(min-width: 1280px)',
    [types_1.WindowBreakpoint.Lg]: '(min-width: 1280px) and (max-width: 1919px)',
    [types_1.WindowBreakpoint.GtLg]: '(min-width: 1920px)',
    [types_1.WindowBreakpoint.Xl]: '(min-width: 1920px)',
};
